import { Input } from '@eliadmin/core/src/components/ui/input';
import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

export function AttributePrice() {
  const max = useCategoryStore(state => state.category.price.max);
  const min = useCategoryStore(state => state.category.price.min) ?? 0;
  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const selectedMin = useCategoryStore(state => state.filter.price_min);
  const selectedMax = useCategoryStore(state => state.filter.price_max);
  const [priceRange, setPriceRange] = React.useState<number[]>([
    selectedMin > 0 ? selectedMin : min,
    selectedMax > 0 ? selectedMax : max ?? 100000,
  ]);
  const generalLayout = useGlobalStore(s => s.generalLayout);
  const currency = generalLayout.currency;

  const setFilter = useCategoryStore(state => state.setFilter);

  React.useEffect(() => {
    // Metadata/back navigation update only the display, never implicit URL filters.
    setPriceRange([
      selectedMin > 0 ? selectedMin : min,
      selectedMax > 0 ? selectedMax : max ?? 100000,
    ]);
  }, [clearTrigger, min, max, selectedMin, selectedMax]);

  const handlePriceChange = () => {
    const price_min = priceRange[0] <= min ? 0 : priceRange[0];
    const price_max = max !== null && priceRange[1] >= max ? 0 : priceRange[1];
    if (price_min === selectedMin && price_max === selectedMax) return;
    setFilter({ price_min, price_max });
  };

  if (max === null) return null;

  return (
    <div className={cn('flex flex-col gap-5 py-2', 'ea-attribute-price')}>
      <div className="w-full px-3 py-0.5">
        <Slider
          isDual
          value={priceRange}
          min={min}
          max={max}
          aria-label="Price range"
          onValueChange={value => setPriceRange(value)}
          onBlur={handlePriceChange}
          className=""
        />
      </div>
      <div
        className={cn(
          'flex w-full flex-row items-center justify-between gap-2',
          'ea-attribute-price__wrapper',
        )}
      >
        <Input
          className={{
            wrapper: cn('flex-1 rounded-full', 'ea-attribute-radio__input-min'),
            main: cn('rounded-full bg-input px-4'),
          }}
          name={'min'}
          value={priceRange[0]}
          disabled
          after={<span className="pr-4 font-semibold">{currency}</span>}
        />
        <Input
          className={{
            wrapper: cn('flex-1 rounded-full', 'ea-attribute-radio__input-max'),
            main: cn('rounded-full bg-input px-4'),
          }}
          name={'max'}
          value={priceRange[1]}
          disabled
          after={<span className="pr-4 font-semibold">{currency}</span>}
        />
      </div>
    </div>
  );
}
